import Hub from '../hub.js';

const CLASS_NAME = 'has-drawer';

Hub.subscribe(Hub.DRAWER_OPEN, () => document.body.classList.add(CLASS_NAME));
Hub.subscribe(Hub.DRAWER_CLOSE, () => document.body.classList.remove(CLASS_NAME));
